import Show from './components/Show'

export default [
  {path: '/presence/:id/show', component: Show, name: 'presence.show'}
]
